import { render, staticRenderFns } from "./BidHistory.vue?vue&type=template&id=6f4a2d2a&"
import script from "./BidHistory.vue?vue&type=script&lang=js&"
export * from "./BidHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports